// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"305b1b4a","213":"5460a33d","337":"e91b7654","455":"dc737e83","512":"f176141d","585":"3727bb72","735":"f156d524","836":"b63b7b1d","840":"7a77c43e","857":"01f5829a","885":"a7708f90","890":"ef9a31f6"}[chunkId] + ".chunk.js";
};